<div class="inner-page">
<div class="header">
    <h2>About</h2>
</div>
<div class="content">
    <p>BuzzBee – connects businesses and local influencers, who experience and promote the business for free. We believe that effective marketing lies in localized advocators who have a genuine interest in the business and are willing to promote it based on the experience.</p>
</div>
</div>